import { gql } from '@apollo/client';
import { WmsNoUpdateQueryFilterInput } from '../../types/dashboard/WmsNoUpdateTypes';

export const GENERATE_WMS_NO_UPDATE_DETAIL_DOWNLOAD_REPORT = gql`
    mutation GenerateWmsNoUpdateDetailDownloadReport(
        $filter: WmsNoUpdateQueryFilterInput!
        $timezone: String
    ) {
        generateWmsNoUpdateDetailDownloadReport(filter: $filter, timezone: $timezone)
    }
`;

export interface GenerateWmsNoUpdateDetailDownloadReportVariables {
    filter: WmsNoUpdateQueryFilterInput;
    timezone?: string;
}

export interface GenerateWmsNoUpdateDetailDownloadReportResponse {
    generateWmsNoUpdateDetailDownloadReport: string;
}
